import {
  ActivityCard,
  LinkButton,
  Page,
  SparkLiquidityLayerIcon,
  SparkLiquidityLayerModal
} from '@/components';
import { useSparkColor } from '@/hooks';
import { Flex, Heading } from '@blockanalitica/ui';
import APYKpi from './APYKpi';
import AssetsTable from './AssetsTable';
import AUMDistributionBreakdown from './AUMDistributionBreakdown';
import AUMKpiWithChart from './AUMKpiWithChart';
import LatestAllocations from './LatestAllocations';
import RevenueSection from './RevenueSection';

export default function SparkLiquidityLayerPage() {
  const color = useSparkColor();

  return (
    <Page
      title={
        <Flex alignItems="center" gap="xs">
          <SparkLiquidityLayerIcon size="4" />
          <Heading>Spark Liquidity Layer</Heading>
          <SparkLiquidityLayerModal iconSize="2" />
        </Flex>
      }>
      <Flex
        flexDirection={['column', 'column', 'row']}
        gap="s"
        alignItems={['stretch', 'stretch', 'flex-start']}>
        <Flex flex="1">
          <AUMKpiWithChart />
        </Flex>
        <Flex flex="1">
          <APYKpi />
        </Flex>
      </Flex>

      <AUMDistributionBreakdown />
      <RevenueSection />
      {/* <AssetsKpiWithChart /> */}

      {/* <ALMCarousel marginTop="s" /> */}

      <Flex flexDirection="column" gap="xs">
        <Flex justifyContent="space-between" alignItems="center">
          <Heading size="2">Allocated Assets</Heading>
          <LinkButton to="assets" variant="whiteAndUgly" fontSize="-1">
            View all
          </LinkButton>
        </Flex>
        <AssetsTable />
      </Flex>

      <LatestAllocations marginTop="s" />
      <ActivityCard
        url="/sparkstar/sll/heatmap/"
        linkTo="activity"
        onClickUrl="activity"
        color={color}
        marginTop="s"
      />
    </Page>
  );
}
